import { UnitCategoryRead } from "@types";

export function getUnitCategoryDetails(data?: UnitCategoryRead | null) {
  if (!data) return { sections: [] };

  const sections: any[] = [];

  if (data.videoUrl) {
    sections.push({
      type: "video",
      title: "Video",
      icon: "pi-video",
      href: data.videoUrl,
      text: "Watch video",
    });
  }

  sections.push({
    title: "General Info",
    icon: "pi-info-circle",
    fields: [
      { label: "Category Name", value: data.label },
      { label: "Short Description", value: data.shortDescription },
      { label: "Main Description", value: data.mainDescription },
      { label: "Best For", value: data.bestFor },
    ],
  });

  sections.push({
    title: "Extra Descriptions",
    icon: "pi-list",
    fields: [
      { label: "Description 1", value: data.description1 },
      { label: "Description 2", value: data.description2 },
      { label: "Description 3", value: data.description3 },
      { label: "Description 4", value: data.description4 },
    ],
  });

  return { sections };
}
